<template>
  <v-dialog v-model="show" max-width="400px">
    <v-card>
      <v-card-title>
        <div class="headline">Delete Company</div>
      </v-card-title>
      <v-card-text>Are you sure you want to this company delete?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="close">No</v-btn>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteCompany(id)">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['id', 'show', 'deleteCompany'],
  methods: {
    close () {
      this.$emit('closeModal', 'deleteCompanyModalDialog')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeleteCompanyModal.vue?dd8692d2